var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * A function that detects objects and allows for filtering out non-intuitive object types.
 *
 * Note that this function does NOT distinguish between "plain" objects and class instances
 * (e.g., `{}` and `new Date()` are both objects).
 */
export function isObject(val, _a) {
    var _b = _a === void 0 ? {} : _a, 
    // TODO(improvement): Add the ability to accept only plain objects (i.e., no class instances).
    // Could use https://github.com/jonschlinkert/is-plain-object as a guide.
    _c = _b.acceptArray, 
    // TODO(improvement): Add the ability to accept only plain objects (i.e., no class instances).
    // Could use https://github.com/jonschlinkert/is-plain-object as a guide.
    acceptArray = _c === void 0 ? false : _c, _d = _b.acceptFunction, acceptFunction = _d === void 0 ? false : _d, _e = _b.acceptNull, acceptNull = _e === void 0 ? false : _e;
    var result = true;
    // Check for all object types.
    if (typeof val !== 'object' && typeof val !== 'function')
        result = false;
    // Check for an array.
    if (Array.isArray(val) && !acceptArray)
        result = false;
    // Check for a function.
    if (typeof val === 'function' && !acceptFunction)
        result = false;
    // Check for null.
    if (val === null && !acceptNull)
        result = false;
    return result;
}
export function pick(obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return keys.reduce(function (building, key) {
        building[key] = obj[key];
        return building;
    }, {});
}
export function remove(obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return Object.keys(obj)
        .filter(function (key) { return !keys.includes(key); })
        .reduce(function (building, key) {
        building[key] = obj[key];
        return building;
    }, {});
}
export function removeValues(obj, values) {
    return Object.entries(obj)
        .filter(function (_a) {
        var _b = __read(_a, 2), val = _b[1];
        return !values.includes(val);
    })
        .reduce(function (result, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        result[key] = val;
        return result;
    }, {});
}
/**
 * Given any data type, safely converts it to a string
 * that accurately represents the input type
 */
export function anythingToString(input) {
    if (typeof input === 'object')
        return JSON.stringify(input);
    if (typeof (input === null || input === void 0 ? void 0 : input.toString) === 'function')
        return input.toString();
    return String(input);
}
